<template>
  <header class="bg-bg-secondary dark:bg-gray-800 shadow-md dark:shadow-lg fixed top-0 left-0 right-0 z-30 transition-all duration-300 border-b border-border-primary dark:border-gray-700" :class="{'pl-0 lg:pl-[268px]': isSidebarOpen && (isAdminPanel || isSuperAdminPanel)}">
    <div class="px-4 py-3 flex justify-between items-center">
      <!-- Logo und Menü-Toggle -->
      <div class="flex items-center">
        <button 
          v-if="isAdminPanel || isSuperAdminPanel" 
          @click="toggleSidebar" 
          class="mr-4 p-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-bg-accent dark:hover:bg-gray-700 transition-colors duration-200 focus:outline-none"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <div class="flex items-center">
          <img 
            v-if="restaurantStore.logoDataUrl"
            :src="restaurantStore.logoDataUrl"
            alt="Restaurant Logo"
            class="h-8 w-auto"
            @error="handleImageError"
          />
          <span v-else class="text-xl font-bold text-gray-900 dark:text-white">
            {{ restaurantStore.settings?.name || 'Restaurant' }}
          </span>
        </div>
      </div>
      
      <!-- User Profile & Actions -->
      <div class="flex items-center space-x-3 md:space-x-4">
        <slot name="actions"></slot>
        <NotificationMenu />
        <UserMenu />
      </div>
    </div>
  </header>
</template>

<script setup>
import { defineEmits, onMounted } from 'vue'
import NotificationMenu from '@/components/layout/NotificationMenu.vue'
import UserMenu from '@/components/layout/UserMenu.vue'
import { useRestaurantStore } from '@/stores/restaurant'
import { useAuthStore } from '@/stores/auth'

defineProps({
  isSidebarOpen: Boolean,
  isAdminPanel: Boolean,
  isSuperAdminPanel: Boolean
})

const emit = defineEmits(['toggle-sidebar'])
const restaurantStore = useRestaurantStore()
const authStore = useAuthStore()

const handleImageError = (event) => {
  console.warn('Restaurant-Logo konnte nicht geladen werden, fallback auf Namen:', event.target.src)
  // Lokal entfernen, damit kein dauerhaft kaputtes Bild gerendert wird
  if (restaurantStore.logoDataUrl) {
    restaurantStore.logoDataUrl = null
  }
};

onMounted(() => {
  console.log('AppHeader mounted:', {
    isAdmin: authStore.isAdmin,
    isSuperAdmin: authStore.isSuperAdmin,
    initialized: restaurantStore.initialized,
    settings: restaurantStore.settings,
    logoDataUrl: restaurantStore.logoDataUrl
  });

  // Wenn der Benutzer ein Admin ist und der Store noch nicht initialisiert wurde
  if ((authStore.isAdmin || authStore.isSuperAdmin) && !restaurantStore.initialized) {
    restaurantStore.fetchRestaurantSettings().then(() => {
      console.log('Restaurant-Einstellungen geladen:', {
        settings: restaurantStore.settings,
        logoDataUrl: restaurantStore.logoDataUrl
      });
    });
  }
})

const toggleSidebar = () => {
  emit('toggle-sidebar')
}
</script> 